import { StratusStatsCardComponentTemplateModel } from "./StratusStatsCardComponentTemplateModel";
import { StratusStatsCardTableHeadingTemplateModel } from "./StratusStatsCardTableHeadingTemplateModel";

export class StratusStatsCardTemplateModel {
    heading: string;
    content: StratusStatsCardComponentTemplateModel[];
    tableHeaders: StratusStatsCardTableHeadingTemplateModel[];

    constructor(heading: string) {
        this.heading = heading;
        this.content = [];
        this.tableHeaders = [];
    }
}